<template>
    <div v-on:click="addNewAnnouncements">
        <div class="container-modal">
            <b-button v-b-modal.modalAddAnnouncement class="btnAdicionarComunicado">
                +
            </b-button>
        </div>
          <b-modal hide-footer size="md" centered id="modalAddAnnouncement" ref="modalAddAnnouncement" title=""
            class="centralizatexto">
            <template #modal-title>
              <div class="title-popup">{{title}}</div>
            </template>

        <div>
            <div v-if="principal" class="parte-1">
                <label class="labelseach mt-3">Para qual Aplicativo este comunicado será direcionado?</label>
                <select  v-model="comunicadoInfos.aplicativo" class="form-control" ref="selectAplicativo">
                    <option v-for="app in aplicativos" :key="app.value" :value="app.value">{{app.text}}</option>
                </select>

                <label class="labelseach mt-3">Destino do comunicado</label>
                <select v-model="comunicadoInfos.destino" class="form-control" ref="selectDestino">
                    <option v-for="dest in destinos" :key="dest.value" :value="dest.value">{{dest.text}}</option>
                </select>

                <div v-if="comunicadoInfos.destino == 1">
                    <label class="labelseach mt-3">Selecione o Empreendimento</label>
                    <select v-model="comunicadoInfos.empreendimentoId" class="form-control" ref="selectEmpreendimento">
                        <option v-for="add in empreendimento" v-bind:key="add.value" :value="add.value">{{add.text}}</option>
                    </select>
                </div>
            </div>

            <div v-if="!principal" class="parte-2">
                    <input type="file" v-on:change="GetValueFile" id="impor-pdf" itemid="impor-pdf">
                    <div class="embaixo">
                    <div class="d-flex justify-content-center">
                        <div>
                        <div v-if="this.type == true" v-on:click="openFilePdf" class="Icon-downoload-documentos">
                            <i class="fas fa-file-image"></i>
                        </div>
                        <div v-else v-on:click="openFilePdf" class="Icon-downoload-documentos">
                            <i class="fas fa-file-pdf"></i>
                        </div>
                    <div>
                        <div class="d-flex justify-content-center mt-2">
                        <label>{{ nameInput }}</label>
                        </div>
                    </div>
                        </div>
                    </div>

                    </div>

                <VueEditor v-model="comunicadoInfos.descricao" :editorToolbar="customToolbar" class="editorSize"></VueEditor>
            </div>
            <div class="btn-add">
                <button  v-on:click="voltar" ref="btn_voltar" class="botoesPopUp"> VOLTAR </button>
                    <button  v-if="btnAvancar" v-on:click="avancar" v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" ref="btn_avancar" class="botoesPopUp" >
                        AVANÇAR
                    </button>
                <button v-if="btnAdicionar" id="btn-adicionar" class="botoesPopUp" v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" v-on:click="add"> ADICIONAR </button>
            <button v-if="btnAtualizar" id="btn-atualizar" class="botoesPopUp" v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" v-on:click="att"> ATUALIZAR </button>
            </div>
        </div>
        </b-modal>
    </div>
</template>

<script>

import addAnnouncements from './addAnnouncements'
export default addAnnouncements

</script>

<style scoped>
.Icon-downoload-documentos {
  align-items: center;
  display: flex;
  width: 460px;
  height: 60px;
  color: rgb(147, 137, 139);
  font-size: 35px;
  justify-content: center;
  cursor: pointer;
}
#impor-pdf {
  display: none;
}
#downloadIconPopUp:hover{
    cursor: pointer;
}
.embaixo {
    border-style: dotted;
    background-color: #ffffff;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    color: rgb(147, 137, 139);
    margin-bottom: 1rem;
}
.container-modal {
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 100px;
}

.btnAdicionarComunicado{
  background-color: #008148;
  bottom: 56px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 26px;
  position: fixed;
}

.btnAdicionarComunicado:hover{
  background-color: #008148;
}

.btn-add{
    display: flex;
    justify-content: space-around;
    margin-top: 70px;
    gap: 3em;
}

.botoesPopUp{
    width: 251px;
    height: 41px;
    background: #DEDEDE 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}

.btn-adicionar{
    background-color: #008148;
}

.editorSize{
    height: 250px;
    font: normal normal normal 18px/24px Segoe UI;
}

#parte2-label{
    padding-bottom: 20px;
}

#parte2-input-pdf{
    margin-bottom: 20px;
}

#parte2-campo{
    margin-bottom: 20px;
    font: normal normal normal 18px/24px Segoe UI;
    color: #707070;
    background-color: #fafafa;
}

div.ql-editor{
    font: normal normal normal 18px/24px Segoe UI;
}

h5.modal-title{
    font-weight: bold;
}

.title-popup{
    justify-self: center;
    grid-row: 1;
    grid-column: 1;
    font-size: 16px;
    text-transform: uppercase;
    color: white;
}

.buttonclose{
    border-radius: 50px;
    border: none;
    background: transparent;
    color: white ;
    opacity: 100%;
    text-align: center;
    justify-self: end;
    grid-row: 1;
    grid-template: 1;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/announcements/components/addAnnouncements/addAnnouncements.vue